import { useEffect, useState } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { usePostIsValidCreateConceptGroupUploadMutation } from '@verantos-dev/data-access-concept-groups';

export const useValidateFile = (file: File | null) => {
  const [mutation, { isLoading, data, error }] = usePostIsValidCreateConceptGroupUploadMutation();
  const [err, setErr] = useState(error);

  const validate = async () => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      await mutation(formData).unwrap();
    }
  };

  useEffect(() => {
    setErr(undefined);
  }, [file]);

  useEffect(() => {
    setErr(error);
  }, [error]);

  return {
    validate,
    isValidating: isLoading,
    concepts: data?.data,
    warnings: data?.warnings ?? null,
    validationError: err,
  };
};
